module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-600italic-ad3b67d74a9d06a2b3c33e303f709576.eot";